module.exports = __webpack_public_path__ + "static/media/check-mark.8c0f8a54.svg";